import React from 'react'
import { useMutation } from 'react-query'
import hooks from '../../../hooks'

const useSurveyMutation = ({
    surveyId,
    onSuccess = () => {},
}) => {
    const [rating, setRating] = React.useState(0)
    const [feedback, setFeedback] = React.useState('')
    const cacheKeys = hooks.useCacheKeys()
    const { api, endpoints, url } = hooks.useApi()
    const { id: userId } = hooks.useCurrentUser()
    const { toastError, toastSuccess } = hooks.useToasts({ successMessage: 'Survey Submitted! Thank you!', onSuccess })
    const { clearCache } = hooks.useCache({ key: cacheKeys.COURSE_SURVEYS, onReload: toastSuccess })
    
    const [ submitSurvey, { isLoading }] = useMutation(
        () => api.post(url(endpoints.userCourseSurvey, { surveyId, userId }), {feedback, rating}),
        {
            onSuccess: clearCache,
            onError: toastError
        }
    )

    return {
        submitSurvey,
        isSubmittingSurvey: isLoading ,

        rating,
        setRating,
        feedback,
        setFeedback
    }
}

export default useSurveyMutation
